<template lang='pug'>
  .attachable.images.input.component
    input(
      type='file'
      ref='upload'
      style='display: none'
      accept='image/*'
      :key='key'
      @change='upload( $event, images )' multiple
    )
    sortable.sortable.thumbs(
      v-model='images'
      handle='.image-container'
    )
      template( v-slot:header )
        flex.upload-container.actionable.centered( @click.native='$refs.upload.click()' )
          .icon
            new-icon
          span {{ 'Add Images' }}

      .image-container(v-for='image, i in images' :key='`image-${i}-${image.id}`')
        .delete(@click='del(image, i)')
          delete-icon
        flex.centered.draggable
          draggable-icon
        img( :src='image.src' )
</template>

<script>
  import { db, str } from '@/main'
  import Administrable from '@/mixins/firebase/administrable'
  import Flex from '@/components/containers/flex'
  import NewIcon from 'vue-material-design-icons/Plus'
  import DraggableIcon from 'vue-material-design-icons/Drag'
  import DeleteIcon from 'vue-material-design-icons/DeleteOutline'
  import FlatButton from '@/components/buttons/flat'
  
  import Sortable from 'vuedraggable'

  export default {
    name: 'attachable.images.input.component',

    props: {
      collection: { type: String, required: true },
      pid: { type: String, required: true }
    },

    mixins: [ Administrable ],

    components: {
      Sortable,
      Flex,
      NewIcon,
      DraggableIcon,
      DeleteIcon,
      FlatButton
    },

    data() {
      return {
        key: 0,
        images: []
      }
    },

    firestore() {
      return {
        images: db.collection( this.collection ).doc( this.pid ).collection( 'images' ).orderBy( 'index' )
      }
    },

    methods: {
      upload( e, images ) {
        console.log('uploading')
        Array.from( e.target.files ).forEach( file => {
          let reader  = new FileReader()
          reader.addEventListener('load', () => {
            const name = file.name
            let img = new Image()
            img.src = reader.result
            img.onload = () => {
              let width = img.width
              let height = img.height
              let ratio = img.width / img.height
              if ( img.width > 800 ) {
                width = 800
                height = width / ratio
              }
              else if ( img.height > 800 ) {
                height = 800
                width = height * ratio
              }
              const elem = document.createElement('canvas')
              elem.width = width
              elem.height = height
              const ctx = elem.getContext( '2d' )
              ctx.drawImage( img, 0, 0, width, height )
              ctx.canvas.toBlob( blob => {
                const file = new File([blob], name, {
                  type: 'image/jpeg',
                  lastModified: Date.now()
                })
                images.push({ src: reader.result, file: file })
              }, 'image/jpeg', 1)
            }
            
          }, false)

          reader.readAsDataURL(file)
        })
      },

      set() {
        let sub = db.collection( this.collection ).doc( this.pid ).collection( 'images' )
        this.images.forEach( ( img, i ) => {
          if ( !img.id ) {
            let path = `/${this.collection}/${this.pid}/images/${img.file.name}`
            let ref = str.ref( path )
            ref.put( img.file ).then( snap =>
              snap.ref.getDownloadURL().then( url => 
                sub.add({ 
                  src: url, 
                  index: i, 
                  path: path 
                })
              ).then( () => this.key++ )
            ).catch( e => console.log(e) )
          }
          else sub.doc( img.id ).update({ index: i })
        })
      },

      del( image, i ) {
        if ( image.id ) db.collection( this.collection ).doc( this.pid ).collection( 'images' ).doc( image.id ).delete()
        else this.images = this.images.filter( img => img.src != image.src )
      }
    }
  }
</script>

<style scoped lang="stylus">
  section
    padding 32px 24px

  footer
    border-bottom-left-radius 9px
    border-bottom-right-radius 9px
    overflow hidden
    .flat.button
      width 50%
      font-family Baloo
      font-size 1.25em

  .sortable
    display grid
    grid-template-columns repeat( auto-fill, minmax( 128px, 1fr ) )
    grid-gap 2.8vh 2.8vw
    grid-auto-rows 128px
    @media( max-width: 480px )
      grid-template-columns repeat( auto-fill, minmax( 96px, 1fr ) )
      grid-auto-rows 96px

  .image-container
    border-radius 13px
    overflow hidden
    position relative
    cursor grab
    .delete
      position absolute
      top 0
      right 0
      color white
      padding 4px 8px
      background rgba( 0 0 0 .25 )
      border-bottom-left-radius 13px
      z-index 2
    .draggable
      position absolute
      height 100%
      width 100%
      background radial-gradient(circle at center, rgba( 0 0 0 .3) , rgba( 0 0 0 .1 ), rgba( 0 0 0 0 ) 100%)
      border-top-right-radius 12px
      font-size 2em
      color white
      z-index 1
    img
      width 100%
      height 100%
      object-fit cover

  .upload-container
    flex-direction column
    background rgba( 255 255 255 .1 )
    border-radius 13px
    height 100%
    width 100%
    border 2px dashed rgba( 0 0 0 .1 )
    cursor pointer
    .icon
      font-size 2em
    span
      font-size .88em
      font-weight bold
      
  .upload-container.save
    background var(--clr-blue)
    color var(--clr-light)

  .image-big 
    position fixed
    top 0
    bottom 0
    left 0
    right 0
    margin auto
    height 600px
    width 450px
    @media(max-width: 420px)
      height 80vh
      width 100vw
      box-sizing border-box
      border 16px solid transparent
    img 
      height 100%
      width 100%
      object-fit cover
    .close 
      position absolute 
      padding 1px
      top 5px
      right 5px
      font-size 22px
      color red
      background rgba( 220 220 220 .5 )
      border-radius 3px
</style>
